import { render, staticRenderFns } from "./SvgText.vue?vue&type=template&id=6ca40161&"
import script from "./SvgText.vue?vue&type=script&lang=js&"
export * from "./SvgText.vue?vue&type=script&lang=js&"
import style0 from "./SvgText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports